import React, {useCallback, useMemo, useState} from "react";
import Button from "../../../../base/button/button";
import TargetProcessTab from "./tabs/process";
import TargetProductsTab from "./tabs/products";
import {Tab, Tabs} from "../../../../base/Tabs";
import useIsMounted from "../../../../../hooks/use-is-mounted";
import {Col, Row} from "reactstrap";
import Api from "../../../../../../core/services/api/api";

export const NCRTargetsTabs = {
    products: "products",
    process: "process",
}

const AddNCRTargetSection = ({
                                 lists,
                                 setLists,
                                 goBack,
                                 tab: tabProps,
                                 submit: submitProps,
                                 reportId,
                                 close,
                             }) => {
    const [tab, setTab] = useState(tabProps ?? NCRTargetsTabs.products);
    const [submitting, setSubmitting] = useState(false);
    const isMounted = useIsMounted();

    const submitButtonDisabled = useMemo(() => (submitting), [submitting]);

    /**
     * Redirects the operator to the lookup search section
     * @param event {MouseEvent}
     * @param newValue {number}
     */
    const onTabClick = useCallback((event, newValue) => {
        setTab(newValue);
    }, [])

    /**
     * Sets the products
     * @type {(function(*): void)}
     */
    const setProducts = useCallback((products) => {
        setLists(prev => ({...prev, products: typeof products === 'function' ? products(prev.products) : products}));
    }, [setLists])

    /**
     * Sets the processes
     * @type {(function(*): void)}
     */
    const setProcesses = useCallback((processes) => {
        setLists(prev => ({...prev, processes: typeof processes === 'function' ? processes(prev.processes) : processes}));
    }, [setLists])

    /**
     * Submits the products and processes
     * @type {(function(): void)}
     */
    const submit = useCallback(async () => {
        setSubmitting(true);
        const [productsResponse, processesResponse] = await Promise.all([
            Api.assignNcrReportParts({
                id: reportId,
                parts: lists.products.map(product => ({
                    originalId: product.id,
                    partNumber: product?.partNumber ?? product?.partNo,
                })),
            }),
            Api.assignNcrReportProcess({
                id: reportId,
                processIds: lists.processes.map(process => process.id),
            })
        ])
        if (!isMounted())
            return;
        setSubmitting(false);
        if (productsResponse?.resultFlag && processesResponse?.resultFlag) {
            submitProps(lists);
        }
    }, [reportId, lists, isMounted, submitProps])

    return (
        <>
            <Row noGutters className={" w-100"}>
                <Col xs={12} className={'d-flex flex-row'}>
                    <div style={{marginTop: '-3rem'}} className={' d-flex flex-column w-100'}>
                        <Tabs
                            centered
                            className={'d-flex flex-column'}
                            value={tab ?? false}
                            scrollButtons={false}
                            variant="fullWidth"
                            onChange={onTabClick}
                            aria-label="result tabs"
                        >
                            <Tab sx={{width: "50%",}} value={NCRTargetsTabs.products} label={"Products"}/>
                            <Tab sx={{width: "50%",}} value={NCRTargetsTabs.process} label={"Process"}/>
                        </Tabs>
                        <div className='w-100 my-3'/>
                        <div className={'d-flex flex-column w-100'}>
                            {
                                tab === NCRTargetsTabs.products &&
                                <TargetProductsTab
                                    products={lists.products}
                                    setProducts={setProducts}
                                    submitting={submitting}
                                />
                            }
                            {
                                tab === NCRTargetsTabs.process &&
                                <TargetProcessTab
                                    processes={lists.processes}
                                    setProcesses={setProcesses}
                                    submitting={submitting}
                                />
                            }
                        </div>
                    </div>
                </Col>
                <div className={"w-100 my-4"}/>
                <Row className="no-gutters footer justify-content-between align-items-start w-100">
                    {
                        goBack &&
                        <Button
                            disabled={submitting}
                            variant={"dialog"}
                            color={"primary"}
                            onClick={goBack}
                            borderRadius={"0 10px 0 10px"}
                        >
                            {submitting ? "submitting..." : "Back"}
                        </Button>
                    }
                    {
                        !goBack &&
                        <div/>
                    }
                    <Row className="no-gutters footer justify-content-end align-items-start">
                        <Button
                            disabled={submitButtonDisabled || submitting}
                            variant={"dialog"}
                            color={"primary"}
                            onClick={() => close()}
                            borderRadius={"10px 0 0 0"}
                        >
                            {submitting ? "submitting..." : "Close"}
                        </Button>
                        <Button
                            disabled={submitButtonDisabled || submitting}
                            variant={"dialog"}
                            color={"primary"}
                            onClick={() => submit()}
                            borderRadius={"0 0 10px 0"}
                        >
                            {submitting ? "submitting..." : "Submit"}
                        </Button>
                    </Row>
                </Row>

            </Row>

        </>
    );
}

export default AddNCRTargetSection;
